/**
 * The "Commercial rights included" grid.
 *
 * Each row carries two icons: the right's own subject icon on the left and a fixed
 * green tick on the right. The tick is aria-hidden — every row in this grid is
 * granted, so announcing "check" on all of them adds nothing for a screen reader.
 */
import { CheckCircle2 } from 'lucide-react';
import { LICENSE_ICONS, LICENSE_RIGHTS } from '../../data/license';
import { c } from '../../styles/theme';

export default function LicenseRightsGrid() {
  return (
    <>
      <p style={{ fontSize: 12, color: c.text3, margin: '0 0 8px' }}>Commercial rights included</p>
      <div className="lyx-grid-2" style={{ marginBottom: 18 }}>
        {LICENSE_RIGHTS.map((r) => {
          // Falls back rather than crashing if the data names an icon that has not
          // been added to LICENSE_ICONS — likely once a backend serves this list.
          const Icon = LICENSE_ICONS[r.icon] ?? CheckCircle2;
          return (
            <div
              key={r.title}
              style={{
                border: `1px solid ${c.border}`,
                borderRadius: 10,
                padding: '10px 12px',
                background: c.surface1,
                display: 'flex',
                gap: 10,
                alignItems: 'flex-start',
              }}
            >
              <Icon size={15} color={c.accent} style={{ flexShrink: 0, marginTop: 2 }} />
              <div style={{ flex: 1, minWidth: 0 }}>
                <p style={{ fontSize: 12, fontWeight: 500, margin: '0 0 2px' }}>{r.title}</p>
                <p style={{ fontSize: 11, color: c.text3, margin: 0 }}>{r.desc}</p>
              </div>
              <CheckCircle2
                size={13}
                color={c.success}
                style={{ flexShrink: 0, marginTop: 2 }}
                aria-hidden="true"
              />
            </div>
          );
        })}
      </div>
    </>
  );
}
